<template>
<div class="contents">
  <admin adminType="staff"/>
</div>
</template>
<script>
import Admin from './../Admin/AdminAreaInfo.vue'
export default {
  name: 'staff-area-infos',
  components: {
    Admin
  }
}
</script>